import type { FrameData } from '@/core/annotations'
import type { SkeletonData, Skeleton } from '@/modules/Editor/AnnotationData'
import { isSkeleton } from '@/modules/Editor/annotationTypes/skeleton'
import { createEditablePoint } from '@/modules/Editor/point'
import { serializeNodesWithColors } from '@/modules/Editor/serialization/serializeNodesWithColors'

type SkeletonSerializeMetadata = {
  skeleton?: {
    edges: { from: string; to: string; color?: string }[]
    nodes?: { name: string; color?: string }[]
  }
}

export const skeletonSerializer = {
  serialize(data: Skeleton, metadata?: SkeletonSerializeMetadata): FrameData {
    if (!isSkeleton(data)) {
      throw new Error('skeleton: expected annotation of skeleton type')
    }

    const nodes: SkeletonData['nodes'] = serializeNodesWithColors(
      data.nodes,
      metadata?.skeleton?.nodes,
    )

    if (!metadata?.skeleton?.edges) {
      return { skeleton: { nodes } }
    }

    const {
      skeleton: { edges },
    } = metadata
    return { skeleton: { nodes, edges } }
  },

  deserialize(rawData: FrameData): Skeleton | null {
    if (!rawData.skeleton) {
      return null
    }

    const nodes = rawData.skeleton.nodes.map((node: SkeletonData['nodes'][0]) => ({
      point: createEditablePoint({ x: node.x, y: node.y }),
      name: node.name,
      occluded: node.occluded,
    }))

    return { nodes }
  },
}
